const translations: Record<string, string> = {
  action_save: 'Зберегти',
  action_saving: 'Збереження...',
  // Greeting
  greeting_morning: 'Доброго ранку',
  greeting_day: 'Доброго дня',
  greeting_evening: 'Доброго вечора',

  // Nav sections
  nav_cabinet: 'Кабінет',
  nav_operations: 'Операції',
  nav_system: 'Система',
  nav_platform_admin: 'Платформ Адмін',
  nav_administration: 'Адміністрування',

  // Nav items
  nav_dashboard: 'Дашборд',
  nav_owner_dashboard: 'Дашборд власника',
  nav_platform_dashboard: 'Дашборд',
  nav_platform_tenants: 'Огляд тенантів',
  nav_platform_users: 'Огляд користувачів',
  nav_platform_counterparties: 'Огляд контрагентів',
  nav_platform_assets: 'Огляд активів',
  nav_onboarding: 'Онбординг',
  nav_counterparties: 'Контрагенти',
  nav_assets: 'Активи',
  nav_contracts: 'Контракти',
  nav_documents: 'Документи',
  nav_forecast: 'Прогноз',
  nav_bess: 'BESS',
  nav_comdisp: 'Комерційна диспетчерська',
  nav_monitor: 'Монітор',
  nav_settings: 'Налаштування',
  nav_tenants: 'Тенанти',
  nav_tenant_users: 'Користувачі тенантів',
  nav_roles: 'Ролі',

  // Topbar
  topbar_search: 'Пошук...',
  topbar_notifications: 'Сповіщення',
  topbar_add_station: 'Додати станцію',
  topbar_profile: 'Профіль',
  topbar_settings: 'Налаштування',
  topbar_company: 'Компанія',
  topbar_team: 'Команда',
  topbar_logout: 'Вийти з кабінету',

  // Home page
  home_breadcrumb_home: 'Головна',
  home_breadcrumb_dashboard: 'Дашборд',
  home_export: 'Експорт',
  home_submit_mms: 'Подати MMS',
  home_hourly_chart: 'Погодинний графік виробітку',
  home_vs_yesterday: '↑ 12% vs вчора',
  home_col_hour: 'Година',
  home_col_forecast: 'Прогноз',
  home_col_fact: 'Факт',
  home_col_deviation: 'Відхилення',
  home_col_price: 'Ціна DAM',
  home_col_revenue: 'Дохід',

  // Notifications
  notif_inverter_alarm: 'Інвертор #3 — тривога',
  notif_mms_confirmed: 'MMS звіт підтверджено',
  notif_market_digest: 'Новий дайджест ринку',
  notif_2h: '2 год',
  notif_yesterday: 'вчора',

  // User menu
  user_guest: 'Гість',

  // Assets page
  assets_title: 'Активи',
  assets_subtitle: "Управління енергетичними об'єктами генерації та зберігання",
  assets_search: 'Пошук за назвою або EIC-кодом...',
  assets_all_types: 'Усі типи',
  assets_loading: 'Завантаження активів...',
  assets_not_found: 'Активи не знайдено',
  assets_not_found_hint: 'Активи створюються з профілю контрагента',
  assets_filter_hint: 'Спробуйте змінити фільтри',
  assets_col_asset: 'Актив',
  assets_col_eic: 'EIC-код',
  assets_col_type: 'Тип',
  assets_col_capacity: 'Потужність',
  assets_col_region: 'Регіон',
  assets_col_status: 'Статус',
  assets_col_counterparty: 'Контрагент',

  // Contracts page
  contracts_title: 'Контракти',
  contracts_subtitle: 'Управління PPA, постачаннями та сервісними контрактами',
  contracts_search: 'Пошук за номером або контрагентом...',
  contracts_loading: 'Завантаження контрактів...',
  contracts_not_found: 'Контракти не знайдено',
  contracts_not_found_hint: 'Контракти створюються з профілю активу',
  contracts_filter_hint: 'Спробуйте інший запит',
  contracts_col_number: 'Номер',
  contracts_col_type: 'Тип',
  contracts_col_counterparty: 'Контрагент',
  contracts_col_asset: 'Актив',
  contracts_col_period: 'Період',
  contracts_col_status: 'Статус',

  // Documents page
  documents_title: 'Документи',
  documents_subtitle: 'Управління метаданими документів та верифікація',
  documents_search: 'Пошук за назвою файлу або контрагентом...',
  documents_loading: 'Завантаження документів...',
  documents_not_found: 'Документи не знайдено',
  documents_not_found_hint: 'Документи додаються з профілів активів або контрагентів',
  documents_filter_hint: 'Спробуйте інший запит',
  documents_col_file: 'Файл',
  documents_col_type: 'Тип',
  documents_col_counterparty: 'Контрагент',
  documents_col_asset_contract: 'Актив / Контракт',
  documents_col_status: 'Статус',
  documents_col_uploaded: 'Завантажено',
  documents_col_by: 'Ким',

  // Forecast page
  forecast_title: 'Прогноз',
  forecast_subtitle: 'Прогнозування генерації · ML-модель v0.2.2',
  forecast_export: 'Експорт XLSX',
  forecast_weather_title: 'Погода / Болград',
  forecast_weather_partly_cloudy: 'Малохмарно',
  forecast_weather_insolation: 'Інсоляція',
  forecast_weather_clouds: 'Хмарність',
  forecast_weather_wind: 'Вітер',
  forecast_weather_humidity: 'Вологість',
  forecast_model_title: 'ML-Модель',
  forecast_model_version: 'Версія',
  forecast_model_updated: 'Оновлено',
  forecast_model_horizon: 'Горизонт',
  forecast_model_training: 'Тренування',
  forecast_model_mape: 'MAPE (7 днів)',
  forecast_accuracy: 'Точність прогнозу',
  forecast_accuracy_period: 'за останні 30 днів',

  // Counterparties page
  cp_title: 'Контрагенти',
  cp_subtitle: 'Управління контрагентами та партнерами',
  cp_new: 'Новий контрагент',
  cp_search: 'Пошук за назвою або ЄДРПОУ...',
  cp_loading: 'Завантаження контрагентів...',
  cp_not_found: 'Контрагентів не знайдено',
  cp_not_found_hint: 'Створіть першого контрагента для початку роботи',
  cp_filter_hint: 'Спробуйте інший запит',
  cp_start_onboarding: 'Розпочати онбординг',
  cp_col_name: 'Назва',
  cp_col_edrpou: 'ЄДРПОУ',
  cp_col_country: 'Країна',
  cp_col_status: 'Статус',
  cp_col_onboarding: 'Онбординг',
  cp_col_assets: 'Активи',
  cp_col_created: 'Створено',

  // Onboarding page
  ob_title: 'Онбординг контрагента',
  ob_subtitle: 'Заповніть 5-крокову форму для реєстрації організації в системі Helios.',
  ob_step_company: 'Компанія',
  ob_step_legal: 'Юридичне',
  ob_step_contact: 'Контакт',
  ob_step_bank: 'Банк',
  ob_step_roles: 'Ролі',
  ob_back: 'Назад',
  ob_next: 'Далі',
  ob_submit: 'Надіслати',
  ob_submitting: 'Надсилається...',
  ob_success_title: 'Онбординг надіслано',
  ob_success_text: 'Контрагента створено і очікує перевірки. ID:',
  ob_complete: 'Завершити онбординг',
  ob_completing: 'Завершується...',
  ob_go_to_profile: 'Перейти до профілю',
  ob_fill_required: 'Заповніть усі обов’язкові поля',
  ob_select_role: 'Оберіть хоча б одну роль',

  // Onboarding Step 1 — Company Identity
  ob_s1_title: 'Ідентифікація компанії',
  ob_s1_subtitle: 'Вкажіть основні ідентифікаційні дані вашої компанії.',
  ob_s1_name: 'Назва компанії',
  ob_s1_name_ph: 'напр. Helios Energy ТОВ',
  ob_s1_shortName: 'Скорочена назва',
  ob_s1_shortName_ph: 'напр. Helios',
  ob_s1_edrpou: 'Код ЄДРПОУ',
  ob_s1_edrpou_ph: '8-цифровий код',
  ob_s1_taxId: 'Податковий номер',
  ob_s1_taxId_ph: 'Ідентифікаційний номер платника',
  ob_s1_country: 'Країна',
  ob_s1_country_ph: 'напр. Україна',

  // Onboarding Step 2 — Legal Profile
  ob_s2_title: 'Юридичний профіль',
  ob_s2_subtitle: 'Вкажіть юридичні та реєстраційні дані вашої організації.',
  ob_s2_fullLegalName: 'Повна юридична назва',
  ob_s2_fullLegalName_ph: 'Повна назва юридичної особи згідно реєстру',
  ob_s2_legalAddress: 'Юридична адреса',
  ob_s2_legalAddress_ph: 'Зареєстрована юридична адреса',
  ob_s2_actualAddress: 'Фактична адреса',
  ob_s2_actualAddress_ph: 'Фізична адреса офісу',
  ob_s2_registrationCountry: 'Країна реєстрації',
  ob_s2_registrationCountry_ph: 'напр. Україна',
  ob_s2_vatStatus: 'Статус ПДВ',
  ob_s2_vatStatus_ph: 'Оберіть статус ПДВ',
  ob_s2_vat_registered: 'Зареєстрований',
  ob_s2_vat_not_registered: 'Не зареєстрований',
  ob_s2_vat_exempt: 'Звільнений',
  ob_s2_vatNumber: 'Номер ПДВ',
  ob_s2_vatNumber_ph: 'Ідентифікаційний номер ПДВ',
  ob_s2_directorName: 'ПІБ директора',
  ob_s2_directorName_ph: 'Повне імя генерального директора',
  ob_s2_authorizedPerson: 'Уповноважена особа',
  ob_s2_authorizedPerson_ph: 'ПІБ особи, уповноваженої підписувати',
  ob_s2_basisOfAuthority: 'Підстава повноважень',
  ob_s2_basisOfAuthority_ph: 'Статут / Довіреність / Наказ',

  // Onboarding Step 3 — Primary Contact
  ob_s3_title: 'Основний контакт',
  ob_s3_subtitle: 'Вкажіть головну контактну особу вашої організації.',
  ob_s3_fullName: 'ПІБ',
  ob_s3_fullName_ph: 'напр. Іван Петренко',
  ob_s3_position: 'Посада',
  ob_s3_position_ph: 'напр. Операційний директор',
  ob_s3_email: 'Email',
  ob_s3_email_ph: 'contact@company.com',
  ob_s3_phone: 'Телефон',
  ob_s3_phone_ph: '+380 50 123 4567',
  ob_s3_contactType: 'Тип контакту',
  ob_s3_contactType_ph: 'Оберіть тип контакту',
  ob_s3_ct_technical: 'Технічний',
  ob_s3_ct_legal: 'Юридичний',
  ob_s3_ct_financial: 'Фінансовий',
  ob_s3_ct_dispatch: 'Диспетчерський',
  ob_s3_ct_commercial: 'Комерційний',
  ob_s3_ct_general: 'Загальний',
  ob_s3_isPrimary: 'Встановити як основний контакт',

  // Onboarding Step 4 — Bank Account
  ob_s4_title: 'Банківський рахунок',
  ob_s4_subtitle: 'Вкажіть основні банківські реквізити для розрахунків.',
  ob_s4_bankName: 'Назва банку',
  ob_s4_bankName_ph: 'напр. ПриватБанк',
  ob_s4_iban: 'IBAN',
  ob_s4_iban_ph: 'UA123456789012345678901234567',
  ob_s4_currency: 'Валюта',
  ob_s4_currency_ph: 'ГРН / EUR / USD',
  ob_s4_mfo: 'МФО / SWIFT',
  ob_s4_mfo_ph: 'Код МФО або SWIFT банку',
  ob_s4_accountHolder: 'Власник рахунку',
  ob_s4_accountHolder_ph: 'Юридична назва власника рахунку',
  ob_s4_isPrimary: 'Встановити як основний рахунок',

  // Onboarding Step 5 — Roles
  ob_s5_title: 'Бізнес-ролі',
  ob_s5_subtitle: 'Оберіть усі ролі, що відповідають вашій організації. Можна обрати кілька.',
  ob_s5_selected: 'Обрані ролі',
  ob_s5_none: 'Ролі не обрано',
  ob_s5_role_generator_owner: 'Власник генерації',
  ob_s5_role_generator_owner_desc: 'Володіє та експлуатує активи відновлюваної енергетики',
  ob_s5_role_supplier: 'Постачальник',
  ob_s5_role_supplier_desc: 'Постачає електроенергію кінцевим споживачам',
  ob_s5_role_trader: 'Трейдер',
  ob_s5_role_trader_desc: 'Купує та продає електроенергію на оптових ринках',
  ob_s5_role_consumer: 'Споживач',
  ob_s5_role_consumer_desc: 'Придбаває електроенергію для власного споживання',
  ob_s5_role_balancing_group_member: 'Учасник БГ',
  ob_s5_role_balancing_group_member_desc: 'Бере участь у балансуючій групі',
  ob_s5_role_bess_operator: 'Оператор BESS',
  ob_s5_role_bess_operator_desc: 'Експлуатує системи накопичення енергії',
  ob_s5_role_service_provider: 'Сервісний провайдер',
  ob_s5_role_service_provider_desc: 'Надає технічні або комерційні послуги',

  // Login page
  login_welcome: 'Ласкаво просимо',
  login_subtitle: 'Увійдіть у ваш робочий простір',
  login_label_login: 'Логін',
  login_label_password: 'Пароль',
  login_btn: 'Увійти →',
  login_checking: 'Перевірка...',
  login_error_empty: 'Введіть логін та пароль',
  login_error_wrong: 'Невірний логін або пароль',
  login_error_rate: 'Забагато спроб входу. Спробуйте за {{sec}} с',
  login_error_unavailable: 'Сервер тимчасово недоступний — спробуйте ще раз',
  login_forgot: 'Забули пароль?',
  login_restore: 'Відновити',
  login_new_company: 'Нова компанія?',
  login_demo: 'Запросити демо',

  // BESS page
  bess_title: 'Накопичення енергії',
  bess_subtitle: 'Телеметрія системи зберігання енергії',
  bess_export: 'Експорт',
  bess_soc: 'Рівень заряду (SOC)',
  bess_soh: 'Стан здоров\'я (SOH)',
  bess_status: 'Статус',
  bess_live: 'Онлайн',
  bess_stale: 'Застаріло',
  bess_discharge: 'Розряд / Вихід Активний',
  bess_charge: 'Доступно для заряду',
  bess_power: 'Активна потужність',
  bess_power_flow: 'Напрямок потужності',
  bess_voltage: 'Напруга батареї',
  bess_current: 'Струм батареї',
  bess_bms: 'Статус BMS',
  bess_pcs: 'Статус PCS',
  bess_config: 'Конфігурація',
  bess_nominal_capacity: 'Номінальна ємність',
  bess_nominal_power: 'Номінальна потужність',
  bess_visible_capacity: 'Видима корисна ємність',
  bess_pcs_avail: 'Доступність PCS',
  bess_updated: 'Оновлено',
  bess_refresh: 'Оновити',
  bess_no_telemetry: 'Телеметрія BESS недоступна',
  bess_retry: 'Повторити',
  bess_section_gauges: 'Показники ємності',
  bess_section_battery: 'Стан батареї',
  bess_section_power: 'Потужність та конфігурація',
  bess_section_status: 'Статус системи',

  // UEEX market data
  nav_market: 'Ринок',
  nav_market_ueex: 'УЕБ',
  nav_info_analytics: 'Інфоаналітика',
  nav_owner_home: 'Дашборд',
  nav_disp_home: 'Дашборд',
  nav_sec_dispatch: 'Диспетчерська',
  nav_disp_fact: 'Факт',
  nav_disp_scada: 'SCADA',
  nav_sec_finance: 'Фінанси',
  nav_fin_cashflow: 'Cash Flow',
  nav_fin_pl: 'P&L',
  nav_fin_reports: 'Звітність',
  nav_gen: 'Генерація',
  nav_dispatch2: 'Диспетчеризація',
  nav_incidents: 'Інциденти',
  nav_reports: 'Звітність',
  nav_sec_market: 'Ринок',
  nav_market_prices: 'Ціни',
  nav_gen_deviation: 'Відхилення',
  nav_bess_state: 'Поточний стан',
  nav_fin_income: 'Дохід',
  nav_fin_charges: 'Нарахування',
  nav_fin_bess_arb: 'Арбітраж BESS',
  nav_an_news: 'Новини',
  nav_notifications: 'Сповіщення',
  nav_trade_schedule: 'Торговий графік',
  nav_mms: 'Передача до MMS',
  nav_disp_commands: 'Команди диспетчера',
  nav_scada_monitoring: 'Моніторинг обладнання',
  nav_scada_telemetry: 'Телеметрія',
  nav_scada_control: 'Ручне керування',
  nav_scada_events: 'Події',
  nav_bess_charge: 'Заряд',
  nav_bess_discharge: 'Розряд',
  nav_bess_arbitrage: 'Арбітраж',
  nav_assets_list: 'Перелік СЕС',
  nav_inc_faults: 'Аварії',
  nav_inc_limits: 'Обмеження',
  nav_inc_alarms: 'Тривоги',
  nav_rep_regulatory: 'Регуляторна',
  nav_rep_management: 'Управлінська',
  nav_rep_dispatch: 'Диспетчерська',
  nav_doc_contracts: 'Договори',
  nav_doc_acts: 'Акти',
  nav_doc_correspondence: 'Листування',
  nav_set_users: 'Користувачі',
  nav_set_roles: 'Ролі',
  nav_set_integrations: 'Інтеграції',
  nav_sec_analytics: 'Аналітика',
  nav_an_market: 'Ринок',
  ueex_page_title: 'Українська енергетична біржа',
  ueex_page_subtitle: 'Аукціонні ціни на електроенергію + Гарантії походження (Solar GO)',
  ueex_page_window: 'Період',
  ueex_page_days: 'днів',
  ueex_tab_electricity: 'Електроенергія',
  ueex_tab_solar_go: 'Сонячні GO',
  ueex_tab_auctions: 'Аукціони',
  ueex_kpi_base_wavg: 'BASE — середньозважена ціна',
  ueex_kpi_block_wavg: 'Блочна — середньозважена ціна',
  ueex_kpi_premium: 'BASE premium',
  ueex_chart_price_title: 'Динаміка цін за день (середньозважена за угодами)',
  ueex_chart_volume_title: 'Обсяги реалізації по днях',
  ueex_top_sellers_base: 'Топ продавців BASE (за обсягом у вікні)',
  ueex_no_data: 'Немає даних',
  ueex_seller: 'Продавець',
  ueex_deals: 'Угод',
  ueex_wavg_price: 'Середня ціна',
  ueex_revenue: 'Виручка',
  ueex_solar_banner_title: 'Solar GO — supply-only ринок',
  ueex_solar_banner_text: 'За 90 днів на УЕБ реалізовано 0 МВт·год сонячних сертифікатів. Asking-ціни є reference baseline для прямих B2B контрактів, але автоматизованих угод немає.',
  ueex_solar_avg_ask: 'Avg ask-ціна',
  ueex_solar_sell_positions: 'Виставлено лотів',
  ueex_solar_closed_deals: 'Закрито угод',
  ueex_solar_offered_volume: 'Пропоновано обсяг',
  ueex_solar_chart_title: 'Динаміка цін Solar GO (ask) + пропонований обсяг',
  ueex_recent_auctions: 'Нещодавні аукціони',
  ueex_auc_num: 'Номер',
  ueex_auc_date: 'Дата',
  ueex_auc_type: 'Тип',
  ueex_auc_state: 'Стан',
  ueex_auc_positions: 'Позицій',
  ueex_auc_closed: 'Закрито',
  ueex_widget_title: 'УЕБ — поточні ціни',
  ueex_widget_view_all: 'Деталі',
  ueex_widget_loading: 'Завантаження...',
  ueex_widget_base_label: 'BASE (24/7)',
  ueex_widget_block_label: 'Блочна позиція',
  ueex_widget_solar_label: 'Сонячні GO (ask)',
  ueex_widget_source: 'Джерело: epbets.ueex.com.ua',
  ueex_widget_subtitle: 'Динаміка цін за останні дні',
  ueex_widget_no_recent_data: 'Немає закритих угод за останній тиждень',
  ueex_sections_title: 'Розділи',
  ueex_section_electric_power: 'Електроенергія',
  ueex_section_bilateral_contracts: 'Двосторонні договори',
  ueex_section_solar_go: 'Сонячні ГП',
  ueex_section_renewable_go: 'ВДЕ ГП — порівняння',
  ueex_section_auctions: 'Усі аукціони',
  ueex_external_link: 'Офіційний сайт УЕБ',
  ueex_kpi_peak_wavg: 'PEAK — середньозважена ціна',
  ueex_chart_auctions_title: 'Результати аукціонів з продажу електричної енергії',
  ueex_chart_auctions_subtitle: 'Середньозважена ціна закритих угод по днях, грн/МВт·год без ПДВ',
  ueex_source_note: 'Джерело',
  ueex_bilateral_title: 'Результати торгівлі на ринку двосторонніх договорів',
  ueex_bilateral_subtitle: 'Електроенергетичні позиції',
  ueex_records: 'записів',
  ueex_renewable_title: 'Гарантії походження — усі ВДЕ',
  ueex_renewable_subtitle: 'Порівняння Solar/Wind/Hydro/Bio',
  ueex_renewable_placeholder: 'Графік порівняння буде доданий у наступній ітерації',
  ueex_renewable_data_source: '(дані вже збираються у БД; запит на дашборд — на черзі)',
  ueex_all_auctions_title: 'Усі аукціони у вікні',
  ueex_all_types: 'Усі типи',
  ueex_loading: 'Завантаження даних...',
  ueex_widget_days_suffix: 'д',
  ueex_widget_deals: 'угод',
  ueex_widget_positions: 'лотів',
  ueex_widget_no_peak: 'Немає торгів PEAK у вікні',
  nav_sko: 'СКО',
  sko_page_title: 'Система керування обмеженнями ВДЕ',
  sko_page_subtitle: 'PRS-графіки та події curtailment від Укренерго',
  sko_sections_title: 'Розділи',
  sko_section_prs: 'PRS-графіки',
  sko_section_curtailment: 'Curtailment події',
  sko_section_about: 'Про СКО',
  sko_external_link: 'Офіційний сайт Укренерго ВДЕ',
  sko_prs_banner_title: 'Phase A — Dry-run',
  sko_prs_banner_text: 'XML-графіки формуються з v0.2.2 forecast і зберігаються у БД. SOAP-надсилання до lms.ua.energy буде увімкнено після укладення договору з ОСП і налаштування VPN-каналу.',
  sko_prs_table_title: 'Згенеровані PRS',
  sko_prs_col_date: 'Дата постачання',
  sko_prs_col_asset: 'СЕС',
  sko_prs_col_rev: 'Ред.',
  sko_prs_col_points: 'Точок',
  sko_prs_col_energy: 'Енергія',
  sko_prs_col_status: 'Статус',
  sko_prs_preview: 'Перегляд',
  sko_prs_preview_title: 'Перегляд PRS XML',
  sko_close: 'Закрити',
  sko_loading: 'Завантаження...',
  sko_no_data: 'Немає даних',
  sko_curt_banner_title: 'Лог подій curtailment',
  sko_curt_banner_text: 'Записуй сюди події відключення/обмеження від диспетчера ОСП. Ці дані потім використаються як features у моделі прогнозу та для compliance-звітів.',
  sko_curt_events_title: 'Події curtailment',
  sko_curt_add_event: 'Додати подію',
  sko_curt_col_asset: 'СЕС',
  sko_curt_col_start: 'Початок',
  sko_curt_col_end: 'Кінець',
  sko_curt_col_pct: 'Обмеження',
  sko_curt_col_reason: 'Причина',
  sko_curt_col_source: 'Джерело',
  sko_curt_col_dispatcher: 'Диспетчер',
  sko_curt_active: 'Триває',
  sko_save: 'Зберегти',
  sko_saving: 'Збереження...',
  sko_about_title: 'Про Систему керування обмеженнями ВДЕ',
  sko_about_p1: 'СКО — система Укренерго для двостороннього обміну інформацією з виробниками ВДЕ ("зелений" тариф / аукціонна ціна) щодо disponability та необхідності curtailment.',
  sko_about_p2: 'Виробники мають подавати PRS (Planned Resource Schedule) — добовий 15-хв графік відпуску електроенергії на день вперед через SOAP API (IEC 62325-451-7) на lms.ua.energy. Диспетчер ОСП може давати команди на зменшення навантаження.',
  sko_about_p3: 'Phase A (наразі) — підготовка інфраструктури dry-run: XML-генератор і збір подій curtailment до офіційної інтеграції.',
  sko_about_phase_status: 'Поточний статус фаз:',
  sko_inbox_title: 'Вхідні від ОСП',
  sko_inbox_subtitle: 'Команди СКО (топ-10)',
  sko_inbox_view_all: 'Усі',
  sko_inbox_loading: 'Завантаження...',
  sko_inbox_empty: 'Немає нових команд',
  sko_inbox_no_asset: '(stakeholder-wide)',
  sko_inbox_curtailment_to: 'Обмеження до',
  sko_inbox_ack_in: 'Підтвердити за',
  sko_inbox_min: 'хв',
  sko_inbox_ack: 'Прийняти',
  sko_inbox_details: 'Деталі',
  sko_bell_pending: 'Очікують підтвердження',
  sko_bell_active: 'Активні',
  sko_bell_critical: 'Критичні',
  sko_bell_none: 'Немає команд',
  sko_section_inbox: 'Inbox команд',
  sko_inbox_full_title: 'Усі команди СКО',
  sko_inbox_filter_all: 'Усі статуси',
  nav_trading: 'Трейдинг',
  nav_trading_overview: 'Зведення',
  nav_trading_dam: 'РДН',
  nav_trading_idm: 'ВДР',
  trading_overview_title: 'Зведена аналітика ринку',
  trading_overview_subtitle: 'Спот OREE (РДН + ВДР) vs позабіржова УЕБ vs фактичне вироблення наших СЕС',
  trading_dam_title: 'Ринок на добу наперед',
  trading_dam_subtitle: 'OREE day-ahead — об\'єднана енергосистема України (ОЕС)',
  trading_idm_title: 'Внутрішньодобовий ринок',
  trading_idm_subtitle: 'OREE intraday — об\'єднана енергосистема України (ОЕС)',
  oree_widget_title: 'Ринок електроенергії OREE',
  oree_widget_subtitle: 'Спотові ціни РДН + ВДР, джерело: www.oree.com.ua',
  oree_widget_dam_today: 'Ціна РДН сьогодні',
  oree_widget_idm_today: 'Ціна ВДР сьогодні',
  oree_widget_dam_7d: 'Середня РДН за 7 днів',
  oree_widget_idm_7d: 'Середня ВДР за 7 днів',
  oree_widget_average_label: 'середньозважена ціна',
  oree_widget_days_suffix: 'д',
  oree_dam_label: 'Ринок на добу наперед',
  oree_idm_label: 'Внутрішньодобовий ринок',
  oree_volume_label: 'Обсяг торгів',
  oree_potential_revenue_7d: 'Потенційний дохід за 7 днів',
  oree_potential_revenue_note: 'Скільки б ми заробили, продаючи фактичне вироблення на РДН замість зеленого тарифу',
  oree_tr_zone_label: 'Торгова зона',
  oree_daily_price_title: 'Динаміка середньозваженої ціни за добу',
  oree_hourly_profile_title: 'Ціна та обсяги по годинах за добу',
  oree_vs_ueex_title: 'Порівняння: спотова ціна (OREE) vs позабіржова (УЕБ Базове навантаження)',
  oree_vs_generation_title: 'Потенційний дохід: наше вироблення × ціна РДН (останні 7 днів)',
  oree_vs_generation_note: 'Сума по всіх наших СЕС за фактичними даними інверторів (modbus). Дохід = фактичні МВт·год × ціна РДН тієї години.',
  common_loading: 'Завантаження…',
  oree_kpi_price_unit_note: 'грн/МВт·год · середньозважена за добу',
  oree_kpi_zone_value: 'ОЕС України',
  oree_kpi_zone_note: 'Об\'єднана енергосистема — основна мережа',
  oree_hourly_empty: 'Дані ще не опубліковано на OREE для цієї дати. Оберіть попередню дату.',
  oree_hourly_widget_title: 'РДН — ціна та обсяги по годинах за добу',
  oree_hourly_widget_subtitle: 'Спотові погодинні дані OREE, ринок на добу наперед',
  oree_hourly_kpi_wavg: 'Середньозважена ціна за добу',
  oree_hourly_kpi_peak: 'Пік ціни',
  oree_hourly_kpi_low: 'Мінімум ціни',
  oree_hourly_kpi_total_vol: 'Сумарний обсяг торгів',
  curtailment_banner_title: 'Активне обмеження виробництва',
  curtailment_banner_cap_label: 'Обмеження до',
  curtailment_banner_pct_suffix: 'від nameplate',
  curtailment_banner_since: 'з',
  curtailment_banner_source: 'Джерело',
  curtailment_banner_source_auto: 'автоматично виявлено детектором',
  curtailment_banner_source_sko: 'команда СКО',
  curtailment_banner_source_analyst: 'аналітичне відтворення',
  curtailment_banner_view_sko: 'Деталі СКО',
  nav_osr: 'ОСР',
  osr_page_title: 'Команди ОСР (Оператора Системи Розподілу)',
  osr_page_subtitle: 'Команди обмеження виробництва від місцевого ОСР (Облэнерго) — НЕ компенсуються. На відміну від СКО від Укренерго.',
  osr_log_new: 'Записати команду',
  osr_cancel: 'Скасувати',
  osr_save: 'Зберегти',
  osr_saving: 'Збереження…',
  osr_close_event: 'Закрити',
  osr_status_active: 'Активна',
  osr_info_title: 'Чому це окремо від СКО:',
  osr_info_body: 'ОСР — це команда місцевого оператора (Облэнерго) переданa зазвичай телефоном або email. На відміну від СКО Укренерго, ця компенсація НЕ виплачується. Подаваний на ринок прогноз (DAM) автоматично клемпиться по ОСР-cap.',
  osr_log_form_title: 'Нова команда ОСР',
  osr_field_asset: 'Актив',
  osr_field_started: 'Час початку',
  osr_field_pct: '% від nameplate',
  osr_field_pmax_kw: 'Cap у кВт',
  osr_field_dispatcher: 'Диспетчер (хто передав)',
  osr_field_org: 'Організація',
  osr_field_reason: 'Причина',
  osr_field_notes: 'Нотатки',
  osr_select_asset: 'оберіть СЕС',
  osr_section_active: 'Активні команди',
  osr_section_past: 'Історія',
  osr_empty_active: 'Немає активних команд ОСР.',
  osr_empty_past: 'Поки немає історії.',
  osr_col_asset: 'СЕС',
  osr_col_started: 'Початок',
  osr_col_ended: 'Завершення',
  osr_col_limit: 'Обмеження',
  osr_col_dispatcher: 'Диспетчер',
  osr_col_reason: 'Причина',
  curtailment_banner_title_osr: 'Активне обмеження ОСР (не компенсується)',
  curtailment_banner_title_sko: 'Активна команда СКО (компенсується Укренерго)',
  curtailment_banner_source_dispatcher_phone: 'дзвінок диспетчеру',
  curtailment_banner_source_dispatcher_email: 'email диспетчеру',
  curtailment_banner_view_osr: 'Деталі ОСР',
  greeting_night: 'Доброї ночі',
  d_demo_data: 'демо-дані (API недоступний)',
  d_disp_console: 'Диспетчерський пульт',
  d_ses_plural: 'СЕС',
  d_u_uah: 'грн',
  d_u_mwh: 'МВт·год',
  d_u_mw: 'МВт',
  d_u_gwh: 'ГВт·год',
  d_u_wm2: 'Вт/м²',
  d_kpi_month_rev: 'Дохід з початку місяця',
  d_kpi_guaranteed: 'гарантовано (прогноз × РДН)',
  d_kpi_contract_rdn: 'контракт РДН −3%',
  d_kpi_today_rev: 'Дохід сьогодні',
  d_kpi_sold_da: 'продано напередодні за прогнозом',
  d_kpi_tech_status: 'Технічний стан',
  d_kpi_generating: 'генерують',
  d_kpi_current_status: 'поточний стан станцій',
  d_kpi_updates_auto: 'оновлюється автоматично',
  d_kpi_forecast_today: 'Прогноз на сьогодні',
  d_kpi_expected_gen: 'очікуване вироблення за день',
  d_kpi_fact_now: 'факт зараз',
  d_dkpi_cur_gen: 'Поточна генерація',
  d_dkpi_total_power_now: 'сумарна потужність зараз',
  d_dkpi_modbus_src: 'за даними Modbus / SCADA',
  d_dkpi_model_weather: 'модель v0.2.2 · погодний прогноз',
  d_dkpi_fulfilment: 'Виконання прогнозу',
  d_dkpi_fact_fc_avg: 'факт / прогноз зараз (середнє)',
  d_dkpi_portfolio_eff: 'ефективність по портфелю',
  d_map_title: 'Мапа станцій',
  d_map_weather: 'Погода',
  d_map_no_telemetry: 'немає телеметрії',
  d_map_today_fact: 'Сьогодні (факт)',
  d_map_forecast: 'Прогноз',
  d_map_revenue_guar: 'Дохід (гарант.)',
  d_map_insolation: 'Інсоляція',
  d_map_cloud: 'хмарності',
  d_btn_details: 'Деталі',
  d_rev_title: 'Дохід: план vs факт',
  d_rev_subtitle: 'розрахунковий (прогноз × РДН) проти фактичного · виручка',
  d_p_today: 'Сьогодні',
  d_p_10d: '10 днів',
  d_p_month: 'Місяць',
  d_p_quarter: 'Квартал',
  d_p_year: 'Рік',
  d_rev_estimated: 'Розрахунковий',
  d_rev_actual: 'Фактичний',
  d_rev_losses: 'Втрати',
  d_rev_plan_fulfil: 'Виконання плану',
  d_chart_loading: 'Завантаження…',
  d_chart_no_data: 'Немає даних за період',
  d_plan: 'План',
  d_fact: 'Факт',
  d_plan_forecast: 'План (прогноз)',
  d_gen_title: 'Генерація: план vs факт',
  d_gen_subtitle: 'прогноз проти фактичного вироблення · МВт·год',
  d_gen_shortfall: 'Недобір',
  d_gen_fulfil: 'Виконання',
  d_port_title: 'Станції портфеля',
  d_port_fc_eff: 'еф. прогнозу',
  d_port_rev_day: 'дохід/день',
  d_port_gen_today: 'вироблено сьогодні',
  d_port_not_launched: 'Не запущено',
  d_port_fc_now: 'виконання прогнозу зараз',
  d_port_guar_rev_today: 'Гарант. дохід сьогодні',
  d_port_installed: 'встановлено',
  d_port_open: 'Відкрити сторінку',
  d_ops_incidents: 'Інциденти',
  d_ops_active: 'активних',
  d_ops_no_incidents: 'Активних інцидентів немає',
  d_ops_lost_value: 'Втрачена вигода',
  d_ops_lost_sub: 'недоотриманий дохід · оцінка сьогодні',
  d_ops_by_cause: 'За причиною',
  d_ops_no_losses: 'Втрат немає',
  d_ops_uah_day: 'грн / день',
  d_cause_outage: 'Відключення',
  d_cause_curtail: 'Обмеження ОСР',
  d_ops_resolved: 'усунено',
  d_ops_since: 'з',
  d_ops_days: 'дн',
  d_inv_title: 'Стан інверторів',
  d_inv_sub: 'оцінка за фактичною vs очікуваною потужністю · оновлюється вдень',
  d_inv_working_portfolio: 'Працює (портфель)',
  d_inv_no_data: 'Немає даних',
  d_inv_st_pending: 'Очікує запуску',
  d_inv_all: 'Всі',
  d_inv_inv_working: 'інверторів працюють',
  d_inv_works: 'працює',
  d_inv_questionable: 'під питанням',
  d_inv_offline: 'offline',
  d_inv_night: 'Оцінка вночі недоступна',
  d_inv_no_tele: 'Без телеметрії інверторів',
  d_inv_abbr: 'інв.',
  d_inv_at: 'о',
  d_inv_footer: 'ℹ️ Поінверторної телеметрії на SMA-станціях (Нікополь, Нікеліос) немає — стан оцінюється за сукупною потужністю. Вночі та без сонця оцінка недоступна (це норма, не збій).',
  d_sec_imbalance: 'Небаланс за місяць',
  d_sec_imbalance_sub: 'орієнтовно · ціна небалансу за актами 14–15 числа',
  d_sec_bess: 'BESS-арбітраж',
  d_sec_bess_sub: 'заряд у дешеві години / розряд у дорогі · дані готуються',
  d_sec_settlements_with: 'Розрахунки з',
  d_sec_offtaker: 'офтейкер',
  d_sec_receivables: 'Дебіторка',
  d_sec_payment_due: 'оплата до',
  d_sec_reports: 'Звіти',
  d_bc_home: 'Головна',
  d_bc_dispatch: 'Диспетчерська',
  d_bc_forecast: 'Прогноз',
  d_bc_analytics: 'Аналітика',
  d_bc_market: 'Ринок',
  d_bc_info: 'Новини',
  d_bc_assets: 'Активи',
};

export default translations;
